<template>
  <div id="costed-bom-summary" class="content-body form-wrapper quote-form-wrapper pricing-overview">
    <CostAnalysisViews v-if="partCost"
                           base-currency="CNY"
                           :currency="currency"
                           :conversion-rate="currencyConversionRate"
                           :scope="scope"
                           :cost-item-records="costItemRecords"
                           :partCost="partCost"
                           :loading="loading">
    </CostAnalysisViews>
  </div>
</template>

<script>
import { CostAnalysisViews } from '@/view/cost/components/reports'
import { mapActions } from 'vuex'
export default {
  name: 'CostedBomSummary',
  props: {
    partCost: {
      type: Object,
      require: true
    }
  },
  data () {
    return {
      loading: false,
      partCostId: this.$route.params.id,
      scope: '',
      marginSetting: {},
      currency: '',
      currencyConversionRate: 1.0,
      localCurrency: 'CNY',
      aggregations: []
    }
  },
  components: {
    CostAnalysisViews
  },
  mounted () {
    if (this.partCost) {
      this.currency = this.partCost.currency
      this.currencyConversionRate = this.partCost.exchange_rate
      this.localCurrency = 'CNY'
    }
    this.loadSummaryData(this.$route.params.id)
  },
  computed: {
    costItemRecords: function () {
      let data = _.clone(this.aggregations)
      return _.map(data, (item) => {
        item.cost_quantity = this.partCost.quantity
        if (item.currency !== this.currency) {
          if (item.currency === this.localCurrency) {
            item.price_amount = item.price_amount / this.currencyConversionRate
            item.price_amount_taxed = item.price_amount_taxed / this.currencyConversionRate
            item.price = item.price / this.currencyConversionRate
            item.price_taxed = item.price_taxed / this.currencyConversionRate
            item.cost = item.cost / this.currencyConversionRate
            item.margin = item.margin / this.currencyConversionRate
            item.vat_amount = item.vat_amount / this.currencyConversionRate
            item.currency = this.currency
          } else {
            item.price_amount = item.price_amount * this.currencyConversionRate
            item.price_amount_taxed = item.price_amount_taxed * this.currencyConversionRate
            item.price = item.price * this.currencyConversionRate
            item.price_taxed = item.price_taxed * this.currencyConversionRate
            item.cost = item.cost * this.currencyConversionRate
            item.margin = item.margin * this.currencyConversionRate
            item.vat_amount = item.vat_amount * this.currencyConversionRate
            item.currency = this.currency
          }
        }
        return item
      })
    }
  },
  watch: {
    '$route.params.id' (newVal) {
      if (newVal) {
        this.partCostId = newVal
        this.loadSummaryData(newVal)
      }
    }
  },
  methods: {
    ...mapActions([
      'getCostedBomSummary'
    ]),
    loadSummaryData(id) {
      this.loading = true
      this.getCostedBomSummary(id).then(res => {
        this.loading = false
        this.aggregations = res.data
      })
    }
  }
}
</script>

<style lang="less">
.pricing-overview { .left { width: 70%; } .right { width: 27%; margin-top: 30px; } }
#cost-margin-setting-pivot-table,
#unit-cost-pivot-table,
#cost-summary-pivot-table,
#hard-soft-cost-cmp-table,
#production-engineering-quality-cost-table {
  padding: 5px 0;
  div.mb-3 button.btn.btn-outline-primary { display: none; }
  .text-right { text-align: right; }
}
.costing-summary {
  max-width: 1490px;
  .actions button { float: right; margin-right: 15px; }
  .actions button:last { margin-right: 0; }
}
</style>
